export const type = 'form.modalPanelList';
